// Centralised brand & company info for PlayerReach
export const BRAND = {
  name: "PlayerReach",
  domain: "PlayerReach.io",
  legalEntity: "Numima FZC LLC",
  formationNumber: "4429474.01",
  address: "Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates",
  contactEmail: "hello@playereach.ai",
  commercialEmail: "hello@playereach.ai",
  partnerEmail: "hello@playereach.ai",
  complianceEmail: "hello@playereach.ai",
  effectiveDate: "13 June 2026",
  version: "1.0",
  copyright: `© ${new Date().getFullYear()} PlayerReach. A trading brand of Numima FZC LLC.`,
};
